import { Paper, IconButton } from '@mui/material'
import { MyLocation } from '@mui/icons-material'
import { useMap } from 'react-leaflet'

interface LocationCenterButtonProps {
  userLocation?: {
    latitude: number
    longitude: number
  } | null
}

export function LocationCenterButton({ userLocation }: LocationCenterButtonProps) {
  const map = useMap()

  const handleCenterOnLocation = () => {
    if (userLocation) {
      map.setView([userLocation.latitude, userLocation.longitude], 13, {
        animate: true,
        duration: 0.5,
      })
    }
  }

  // Don't show button if no location available
  if (!userLocation) return null

  return (
    <Paper
      elevation={2}
      sx={{
        position: 'absolute',
        bottom: 10,
        right: 10,
        zIndex: 1000,
        borderRadius: '4px',
        overflow: 'hidden',
      }}
    >
      <IconButton
        onClick={handleCenterOnLocation}
        size="small"
        sx={{
          width: '30px',
          height: '30px',
          borderRadius: '4px',
          padding: 0,
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
          },
        }}
        aria-label="Center on my location"
        title="Center on my location"
      >
        <MyLocation sx={{ fontSize: '18px' }} />
      </IconButton>
    </Paper>
  )
}
